import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./fonts.css";
import "./index.css";
import "./styles.css";
import App from "./App.tsx";

createRoot(document.getElementById("react-app")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
